import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { site } from "@/mocks/site";

export default function HeroBand() {
  const [kw, setKw] = useState("");
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = kw.trim();
    navigate(q ? `/?q=${encodeURIComponent(q)}` : "/");
    if (!q) {
      document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const tickerItems = [...site.hotWords, ...site.hotWords];

  return (
    <section aria-label="站点首屏" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20bustling%20newsroom%20desk%20with%20papers%2C%20a%20magnifier%20and%20warm%20evening%20light%2C%20coral%20red%20and%20golden%20amber%20palette%2C%20minimal%20flat%20design%2C%20cream%20background%2C%20magazine%20cover%20composition%2C%20soft%20grain%20texture&width=1600&height=900&seq=gg-hero-01&orientation=landscape"
          alt="网曝吃瓜编辑部选题整理的抽象插画背景"
          title="网曝吃瓜 - 网友爆料投稿聚集地"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60" />
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-24">
        <div className="max-w-4xl mx-auto text-center rise-in">
          <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-100 text-xs md:text-sm backdrop-blur-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400" />
            今日已整理 {site.stats[1].value} 条在架线索
          </p>

          <h1 className="mt-5 font-brand text-5xl md:text-7xl leading-none text-background-50">
            网友爆料投稿聚集地
          </h1>

          <p className="mt-5 text-base md:text-xl text-background-200 leading-relaxed max-w-2xl mx-auto">
            投稿、素材、线索、原帖一站围观。我们把零散的爆料整理成有时间线、有出处、看得明白的条目，
            <span className="text-accent-300"> 让每一次围观都更有信息量。</span>
          </p>

          <form onSubmit={submit} className="mt-8 max-w-xl mx-auto flex flex-col sm:flex-row gap-2" role="search">
            <div className="relative flex-1">
              <i
                className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400"
                aria-hidden="true"
              />
              <label htmlFor="hero-search" className="sr-only">
                搜索爆料线索
              </label>
              <input
                id="hero-search"
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                placeholder="输入关键词，例如「赛制」「联名」"
                className="w-full h-12 pl-11 pr-4 text-sm rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-400"
              />
            </div>
            <button
              type="submit"
              className="h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              搜索线索
            </button>
          </form>

          <div className="mt-4 flex flex-wrap items-center justify-center gap-2 text-xs text-background-300">
            <span>热词：</span>
            {site.hotWords.slice(0, 6).map((word) => (
              <button
                key={word}
                type="button"
                onClick={() => navigate(`/?q=${encodeURIComponent(word)}`)}
                className="px-2.5 py-1 rounded-md bg-background-50/10 hover:bg-background-50/20 text-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                {word}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* 热榜滚动字幕 */}
      <div className="relative border-t border-background-50/15 bg-black/30">
        <div className="w-full flex items-center overflow-hidden">
          <span className="shrink-0 flex items-center gap-2 px-4 md:px-6 py-2.5 bg-accent-500 text-foreground-950 text-xs md:text-sm font-medium whitespace-nowrap">
            <i className="ri-flashlight-fill" aria-hidden="true" />
            正在跟进
          </span>
          <div className="flex-1 overflow-hidden">
            <div className="ticker-track flex items-center w-max">
              {tickerItems.map((word, i) => (
                <span key={`${word}-${i}`} className="flex items-center gap-3 px-5 text-xs md:text-sm text-background-200 whitespace-nowrap">
                  <i className="ri-record-circle-line text-primary-400" aria-hidden="true" />
                  {word}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}